"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../elements/elements/TestGrouping/constants");
const types_1 = require("../../types");
const font_1 = require("../../font");
const theme_1 = require("../../theme");
const genStyle_1 = require("../genStyle");
const feedback_1 = require("../../feedback");
const styleSchema = {
    common: {
        height: (0, genStyle_1.genStyle)({ value: 200 }),
        width: (0, genStyle_1.genStyle)({ value: 300 }),
        borderRadius: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderRadius }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryTextColor }),
    },
    answer: {
        position: (0, genStyle_1.genStyle)({ value: 'top' }),
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryBackgroundColor }),
        alignItems: (0, genStyle_1.genStyle)({ value: 'center' }),
        borderStyle: (0, genStyle_1.genStyle)({ value: 'solid' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
    answerNavigation: {
        iconsAlign: (0, genStyle_1.genStyle)({ value: types_1.IconsAlignEnum.rightUp }),
    },
    dragButton: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
        height: (0, genStyle_1.genStyle)({ value: 40 }),
        width: (0, genStyle_1.genStyle)({ value: 40 }),
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.lightTextColor }),
        iconsAlign: (0, genStyle_1.genStyle)({ value: types_1.IconsAlignEnum.leftUp }),
    },
    hover: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.focusedColor }),
    },
    group: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryBackgroundColor }),
        alignItems: (0, genStyle_1.genStyle)({ value: 'center' }),
        borderStyle: (0, genStyle_1.genStyle)({ value: 'solid' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
    groupNavigation: {
        iconsAlign: (0, genStyle_1.genStyle)({ value: types_1.IconsAlignEnum.rightUp }),
    },
    progress: {
        borderRadius: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderRadius }),
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.neutralColor }),
        height: (0, genStyle_1.genStyle)({ value: 4 }),
    },
    progressResult: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
    },
    indents: {
        padding: (0, genStyle_1.genStyle)({ value: [16, 16, 16, 16] }),
        marginTop: (0, genStyle_1.genStyle)({ value: 40 }),
        gap: (0, genStyle_1.genStyle)({ value: 48 }),
    },
};
const fontSchema = Object.assign({ answerNumbering: Object.assign({}, font_1.FONT_SCHEMA_EMPTY.base) }, font_1.FONT_SCHEMA_EMPTY);
const feedbackSchema = Object.assign({}, feedback_1.FEEDBACK_SCHEMA_EMPTY);
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: fontSchema, feedback: feedbackSchema } };
